export default (() => {
  if (typeof window.$tyrWebpageData === 'undefined') {
    window.$tyrWebpageData = {}
  }
})()

import './lazy-bg-image'
import './authenticity_token'
import './flash-message'
import './cookie-consent'
import './copy-to-clipboard'
import './on-change-tabs'
import './form-validation'
import './lang-selectors'
import './select-binding'
import './video-autoplay'
import './signed-in'
import './ec-add-to-cart'
import './ec-current-cart'
import './ec-cart-badge'
import './ec-fetch-apply-coupon'
import './ec-product'
import './number-incr-effect'
import './tappay'
import './swal'
import './sticky-stuck'
import './qrcode'
import './remote'
import './ga4_tag'
import './fbq'
import './select2'
import './docout'
import './intl-tel-input'
import './data-confirm'
import './tippy'
